import React, { useState } from 'react';
import { SectionHeading } from '../../../../ui';

export function LandingFAQ() {
  const [expanded, setExpanded] = useState([true, false, false]);
  const syncExpanded = (index: number, open: boolean) => {
    setExpanded(current => current[index] === open ? current : current.map((value, i) => i === index ? open : value));
  };
  const arrow = (index: number) => `/assets/figma/steps-arrow-${expanded[index] ? 'up' : 'up-right'}.svg`;
  return (
    <>
      <section className="section section--how content-width" id="how" data-figma-node="125:48378" aria-labelledby="how-title">
        <SectionHeading
          wide
          title="Как это работает"
          titleId="how-title"
          description="Три шага — и питомец в пути. От заявки до выбора перевозчика обычно проходит несколько часов."
        />
        <div className="how-layout">
          <div className="how-layout__image">
            <img src="/assets/figma/steps-main-3108-49103.webp" alt="Девушка создаёт заявку на перевозку питомца" />
          </div>
          <div className="steps">
            <details open={expanded[0]} onToggle={event => syncExpanded(0, event.currentTarget.open)}>
              <summary><span>01</span><b>Создайте заявку</b><img className="steps__control" src={arrow(0)} alt="" /></summary>
              <div className="steps__body">
                <div className="steps__content">
                  <p>Маршрут, питомец, даты и пожелания. Регистрация — на последнем шаге, заявка не теряется.</p>
                  <a href="#new-request-step-1">Создать заявку <img src="/assets/figma/steps-arrow-link.svg" alt="" /></a>
                </div>
                <span className="steps__media"><img src="/assets/figma/steps-dog-137-36931.webp" alt="Корги" /></span>
              </div>
            </details>
            <details open={expanded[1]} onToggle={event => syncExpanded(1, event.currentTarget.open)}>
              <summary><span>02</span><b>Выберите перевозчика</b><img className="steps__control" src={arrow(1)} alt="" /></summary>
              <div className="steps__body">
                <div className="steps__content">
                  <p>Сравнивайте предложения по цене, рейтингу и фото прошлых перевозок.</p>
                  <a href="#new-request-step-1">Создать заявку <img src="/assets/figma/steps-arrow-link.svg" alt="" /></a>
                </div>
                <span className="steps__media"><img src="/assets/figma/steps-transport-137-36931.webp" alt="Перевозка питомца" /></span>
              </div>
            </details>
            <details open={expanded[2]} onToggle={event => syncExpanded(2, event.currentTarget.open)}>
              <summary><span>03</span><b>Следите за поездкой</b><img className="steps__control" src={arrow(2)} alt="" /></summary>
              <div className="steps__body">
                <div className="steps__content">
                  <p>Фото с каждого этапа в чате. После доставки — оплата и взаимный отзыв.</p>
                  <a href="#new-request-step-1">Создать заявку <img src="/assets/figma/steps-arrow-link.svg" alt="" /></a>
                </div>
                <span className="steps__media"><img src="/assets/figma/steps-chat-137-36931.webp" alt="Чат с перевозчиком" /></span>
              </div>
            </details>
          </div>
        </div>
      </section>

      <section className="final-search content-width" id="final-search" data-figma-node="125:48389" aria-labelledby="final-search-title">
        <SectionHeading
          title="Найти перевозчика"
          titleId="final-search-title"
          description="Оставьте заявку и получите лучшие предложения от профессионалов, одобренных другими владельцами животных!"
        />
        <form
          className="search-pill js-route-form"
          onSubmit={(e) => {
            e.preventDefault();
            window.location.hash = '#new-request-step-1';
          }}
        >
          <label><b>Откуда</b><input name="from" placeholder="Москва" aria-label="Откуда" /></label>
          <i aria-hidden="true"></i>
          <label><b>Куда</b><input name="to" placeholder="Берлин" aria-label="Куда" /></label>
          <button type="submit" aria-label="Найти перевозчика"><span className="search-pill__label">Искать перевозчика</span><img src="/assets/figma/button-arrow-up-right-white.svg" alt="" /></button>
        </form>
      </section>
    </>
  );
}
